<template lang="pug">
div.container-fluid.animated.fadeIn
  nav(aria-label="breadcrumb")
    b-breadcrumb
      b-breadcrumb-item
        router-link(to="/vip")
          i.fas.fa-crown
          span.ml-1 {{ $t("ui.vip") }}
      b-breadcrumb-item(v-if="selectedVipId != null && pageLvl != 'vip'")
        span.ml-1 {{ selectedVipId + " - " + selectedVipName }}
  div.row
    div.col-md-12
      div.card
        div.card-header
          div.row(v-if="pageLvl == 'vip'")
            div.col-md-12
              div
                div.row.col-md-12
                  div(width="80%").mr-3
                    b-button(v-b-modal.addVip type="button" variant="primary" size="sm")
                      i.fa.fa-plus
                      span {{ $t("ui.combine.add_vip") }}
                  div(width="20%")
          div.row(v-else)
            div.col-md-12
              div
                div.row.col-md-12
                  SubmitButton(
                    :loading="loading"
                    icon="icon-arrow-left"
                    :text="$t('ui.back')"
                    type="button"
                    @click="backToVipList"
                    variant="secondary"
                    size="sm"
                  ).mr-1
                  //- SubmitButton(
                  //-   :loading="loading"
                  //-   icon="fa fa-tasks"
                  //-   :text="$t('ui.vip_provider_rebate_batch')"
                  //-   type="button"
                  //-   @click="confirmVipProviderRebateBatch"
                  //-   variant="warning"
                  //-   size="sm"
                  //- )
        div.card-body
          div(v-if="pageLvl == 'vip'")
            div.row.clusterize
              div.col-md-12
                .clusterize-scroll
                  table#myTable.tablex(style="width: 100%;")
                    thead
                      tr
                        th.text-center.sticky-position(width="3%")
                          span #
                        th.sticky-position(width="10%")
                          span(:title="$t('ui.vip_name')") {{ $t("ui.vip_name") }}
                        th.sticky-position.text-right(width="8%")
                          span(:title="$t('ui.deposit')") {{ $t("ui.deposit") }}
                        th.sticky-position.text-right(width="8%")
                          span(:title="$t('ui.turnover')") {{ $t("ui.turnover") }}
                        th.sticky-position.text-right(width="12%")
                          span(:title="$t('ui.maintain_deposit')") {{ $t("ui.maintain_deposit") }}
                        th.sticky-position.text-right(width="12%")
                          span(:title="$t('ui.maintain_turnover')") {{ $t("ui.maintain_turnover") }}
                        th.sticky-position(width="10%")
                          span(:title="$t('ui.reward_type')") {{ $t("ui.reward_type") }}
                        th.sticky-position.text-right(width="8%")
                          span(:title="$t('ui.cash')") {{ $t("ui.cash") }}
                        th.sticky-position(width="10%")
                          span(:title="$t('ui.campaign_id')") {{ $t("ui.campaign_id") }}
                        th.sticky-position(width="10%")
                          span(:title="$t('ui.cs')") {{ $t("ui.cs") }}
                        th.sticky-position(width="10%")
                          span(:title="$t('ui.social_platform')") {{ $t("ui.social_platform") }}
                        th.sticky-position.text-center(width="8%")
                          span(:title="$t('ui.is_default')") {{ $t("ui.is_default") }}
                        th.text-center.sticky-position(width="8%")
                          span(:title="$t('ui.action')") {{ $t("ui.action") }}
                        th.sticky-position(width="8%")
                          span(:title="$t('ui.action_by')") {{ $t("ui.action_by") }}
                    tbody.clusterize-content
                      tr(v-if="vipList.length == 0")
                        td(colspan="12").text-center
                          span {{ $t('message.no_data_available') }}
                      //- tr(
                      //-   v-for="(item, index) in vipList"
                      //-   draggable="true"
                      //-   @dragstart="handleDragStart($event, index)"
                      //-   @dragover.prevent
                      //-   @dragenter="handleDragEnter($event, index)"
                      //-   @dragleave="handleDragLeave"
                      //-   @drop="handleDrop($event, index)"
                      //-   @dragend="handleDragEnd"
                      //-   :id="item.vip_id"
                      //- )
                      tr(
                        v-for="(item, index) in vipList"
                        :id="item.vip_id"
                      )
                        td.text-center
                          span(:title="index + 1") {{ index + 1 }}
                        //- td.grabbable
                        td
                          span(:title="item.vip_name")
                            i.fas.fa-crown(v-if="item.vip_name") &nbsp;{{ item.vip_name }}
                        td.text-right
                          span(:title="$n(item.deposit, 'currency')") {{ item.deposit != null ? $n(item.deposit, 'currency') : null }}
                        td.text-right
                          span(:title="$n(item.turnover, 'currency')") {{ item.turnover != null ? $n(item.turnover, 'currency') : null }}
                        td.text-right
                          span(:title="$n(item.maintain_deposit, 'currency')") {{ item.maintain_deposit != null ? $n(item.maintain_deposit, 'currency') : null }}
                        td.text-right
                          span(:title="$n(item.maintain_turnover, 'currency')") {{ item.maintain_turnover != null ? $n(item.maintain_turnover, 'currency') : null }}
                        td
                          span(:title="item.reward_type") {{ item.reward_type ? item.reward_type : "-" }}
                        td.text-right
                          span(:title="$n(item.cash, 'currency')") {{ item.cash != null ? $n(item.cash, 'currency') : null }}
                        td
                          span(:title="item.campaign_id") {{ item.campaign_id }}
                        td
                          span(:title="item.cs") {{ item.cs }}
                        td
                          span(:title="item.social_platform") {{ item.social_platform }}
                        td.text-center
                          span.isdefault(:title="item.is_default" href="javascript:void(0);" @click="confirmVipDefault(item)")
                            i(:class="{'fas fa-check text-info': item.is_default, 'fas fa-times text-warning': !item.is_default  }")
                        td.actions
                          span
                            a.fa.fa-edit.text-primary(href="javascript:void(0)" @click="onEditVip(item)" :title="$t('ui.edit_vip')")
                          span
                            a.fa.fa-list.text-primary(href="javascript:void(0)" @click="setVipId(item)" :title="$t('ui.edit_vip_provider')")
                        td
                          span(:title="item.action_by") {{ item.modified_by ? item.modified_by : item.created_by }}
          div(v-if="pageLvl == 'vipProvider' && selectedVipId != null")
            div.row.clusterize
              div.col-md-12
                .clusterize-scroll
                  table.tablex(style="width: 60%;")
                    thead
                      tr
                        th.sticky-position.text-center(width="5%")
                          span #
                        th.sticky-position(width="15%")
                          span(:title="$t('ui.provider_code')") {{ $t('ui.provider_code') }}
                        th.sticky-position(width="25%")
                          span(:title="$t('ui.provider_name')") {{ $t('ui.provider_name') }}
                        th.sticky-position.text-center(width="20%")
                          b-form-checkbox.vipCheckbox(
                            size="sm"
                            v-model="srr"
                            :title="$t('ui.self_rebate_rate')"
                            @input="confirmCopyAll('srr', $event)"
                          ) {{ $t("ui.self_rebate_rate") }}
                        th.sticky-position.text-center(width="20%")
                          b-form-checkbox.vipCheckbox(
                            size="sm"
                            v-model="drr"
                            :title="$t('ui.downline_rebate_rate')"
                            @input="confirmCopyAll('drr', $event)"
                          ) {{ $t("ui.downline_rebate_rate") }}
                        //- th.sticky-position(width="20%")
                        //-   span(:title="$t('ui.self_rebate_rate')") {{ $t("ui.self_rebate_rate") }}
                        //- th.sticky-position(width="20%")
                        //-   span(:title="$t('ui.downline_rebate_rate')") {{ $t("ui.downline_rebate_rate") }}
                        th.text-center.sticky-position(width="10%")
                          span(:title="$t('ui.action')") {{ $t("ui.action") }}
                          span
                            a.fa.fa-edit.text-warning(href="javascript:void(0)" @click="confirmVipProviderRebateBatch()" :title="$t('ui.edit_batch')")
                    tbody.clusterize-content
                      tr(v-if="vipProviderList.length == 0")
                        td(colspan="6").text-center
                          span {{ $t('message.no_data_available') }}
                      tr(v-for="(item, index) in vipProviderList")
                        td.text-center
                          span(:title="index + 1") {{ index + 1 }}
                        td
                          span(:title="item.provider_code") {{ item.provider_code }}
                        td
                          span(:title="item.provider_name") {{ item.provider_name }}
                        td
                          b-form-input.text-center(
                            :id="'s_' + item.provider_code + index"
                            size="sm"
                            type="number"
                            step="0.1"
                            min="0"
                            v-model="item.self_rebate_rate"
                            @update="srrCopyAll"
                          )
                        td
                          b-form-input.text-center(
                            :id="'d_' + item.provider_code + index"
                            size="sm"
                            type="number"
                            step="0.1"
                            min="0"
                            v-model="item.downline_rebate_rate"
                          )
                        //- td
                        //-   span(:title="item.self_rebate_rate") {{ item.self_rebate_rate }}
                        //- td
                        //-   span(:title="item.downline_rebate_rate") {{ item.downline_rebate_rate }}
                        td.actions
                          span
                            a.fa.fa-save.text-primary(href="javascript:void(0)" @click="confirmEditVipProvider(item)" :title="$t('ui.save')")
                          //- span
                          //-   a.fa.fa-edit.text-primary(href="javascript:void(0)" @click="onEditVipProvider(item)" :title="$t('ui.edit')")

    addvip(@clicked="addVip" @failed="handleFailed")
    editvip(ref="editvip" :item="selectedVip"  @clicked="afterEditVip" @failed="handleFailed")
    //- editvipprovider(ref="editvipprovider" :vipId="selectedVipId" :item="selectedVipProvider" @clicked="afterEditVipProvider" @failed="handleFailed")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import { required, minLength, maxLength, alphaNum, integer, email, helpers, decimal, requiredIf } from "vuelidate/lib/validators";
import ValidateResult from "@/library/ValidateResult";
import addvip from "@/components/vip/addVip.vue";
import editvip from "@/components/vip/editVip.vue";
// import editvipprovider from "@/components/vip/editVipProvider.vue";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    ValidateResult,
    addvip,
    editvip,
    // editvipprovider
  },
  data: () => ({
    loading: false,
    selected: [],
    vipList: [],
    vipProviderList: [],
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    selectedVipProvider: null,
    selectedVipId: null,
    selectedVipName: null,
    selectedVip: null,
    pageLvl: "vip",
    srr: false,
    drr: false
  }),
  computed: {
  },
  mounted: function() {
    this.pageLvl = 'vip';
    this.getVipList();
  },
  methods: {
    handleDragStart(e, index) {
      // console.log("handleDragStart", e.target.id)
      this.dragSrcIndex = index;
      e.dataTransfer.effectAllowed = 'move';
      e.dataTransfer.setData('text/plain', index);
      e.target.classList.add('dragging');
    },
    handleDragEnter(e, index) {
      e.target.parentElement.classList.add('over');
      // e.target.classList.add('over');
    },
    handleDragLeave(e) {
      e.target.parentElement.classList.remove('over');
      // e.target.classList.remove('over');
    },
    handleDrop(e, index) {
      e.stopPropagation();
      e.target.parentElement.classList.remove('over');
      // e.target.classList.remove('over');

      const dragSrcIndex = this.dragSrcIndex;
      // console.log("handleDrop", dragSrcIndex, index)
      if (dragSrcIndex !== index) {
        const draggedItem = this.vipList[dragSrcIndex];
        const targetItem = this.vipList[index];
        // console.log("draggedItem", draggedItem.vip_id, targetItem.item_order)
        this.confirmVipMove(draggedItem.vip_id, draggedItem.vip_name, targetItem.item_order);
      }

      e.target.classList.remove('dragging');
    },
    handleDragEnd(e) {
      e.target.classList.remove('dragging');
    },
    confirmVipMove: function(vipID, vipName, itemOrder) {
      this.$helpers
        .alert({
          title: this.$t("ui.status"),
          text: this.$t("message.move_vip_confirm", { name: vipName, position: itemOrder }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.vipMove(vipID, itemOrder);
          } else {
            this.getVipList();
          }
        });
    },
    vipMove: function(vipID, itemOrder) {
      let url = config.vipMoveUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId,
        vip_id: vipID,
        item_order: itemOrder,
        audit_by: this.$store.getters.loginId
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.getVipList();
                this.$helpers.showDialog(this.$t("ui.status"), this.$t("message.success"), "success");
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    backToVipList() {
      this.pageLvl = "vip";
      this.selectedVipId = null;
      this.selectedVipName = null;
      this.srr = false;
      this.drr = false;
      this.getVipList();
    },
    setVipId: function (e) {
      this.selectedVipId = e.vip_id;
      this.selectedVipName = e.vip_name;
      this.getVipProviderList();
    },
    onEditVip: function(e) {
      this.selectedVip = e;
      this.$refs.editvip.$refs.editVip.show();
    },
    afterEditVip: function() {
      this.getVipList();
      this.$helpers.showDialog(this.$t("ui.combine.edit_vip"), this.$t("message.success"), "success");
    },
    // onEditVipProvider(e) {
    //   this.selectedVipProvider = e;
    //   this.$refs.editvipprovider.$refs.editVipProvider.show();
    // },
    // afterEditVipProvider: function() {
    //   this.getVipProviderList();
    //   this.$helpers.showDialog(this.$t("ui.combine.edit_vip_provider"), this.$t("message.success"), "success");
    // },
    addVip: function() {
      this.search = "";
      this.getVipList();

      this.$helpers.showDialog(this.$t("ui.combine.add_vip"), this.$t("message.success"), "success");
    },
    getVipList: function() {
      // let url = config.vipLookupUrl();
      let url = config.vipListUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.pageLvl = "vip";
                if (response.data.dt.length > 0) {
                  this.vipList = response.data.dt;
                }
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getVipProviderList: function() {
      let url = config.vipProviderListUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId,
        vip_id: this.selectedVipId,
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.pageLvl = "vipProvider";
                if (response.data.dt.length > 0) {
                  this.vipProviderList = response.data.dt;
                }
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    confirmVipDefault: function(e) {
      this.$helpers
        .alert({
          title: this.$t("ui.status"),
          text: this.$t("message.change_vip_default_confirm", { name: e.vip_name }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.setVipDefault(e);
          } else {
            this.getVipList();
          }
        });
    },
    setVipDefault: function(e) {
      let url = config.vipDefaultUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId,
        vip_id: e.vip_id,
        audit_by: this.$store.getters.loginId
      };

      this.feedback.success = true;
      this.loading = true;

      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.getVipList();
                this.$helpers.showDialog(this.$t("ui.status"), this.$t("message.success"), "success");
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    confirmVipProviderRebateBatch: function() {
      this.$helpers
        .alert({
          title: this.$t("ui.status"),
          text: this.$t("message.vip_provider_rebate_batch_confirm"),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            let modifiedObj = this.vipProviderList.map(item => {
              const { provider_name, ...rest } = item;
                return { vip_id: this.selectedVipId, ...rest };
            });
            this.vipProviderRebateBatch(modifiedObj);
          } else {
            this.getVipProviderList();
          }
        });
    },
    vipProviderRebateBatch: function(csv) {
      let url = config.vipProviderEditBatchUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId,
        vip_provider_rebate: csv,
        audit_by: this.$store.getters.loginId
      };

      this.feedback.success = true;
      this.loading = true;

      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.getVipProviderList();
                this.$helpers.showDialog(this.$t("ui.status"), this.$t("message.success"), "success");
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    confirmCopyAll: function(mode, e) {
      let proceed = false;
      let firstProvider = this.vipProviderList.length > 0 ? this.vipProviderList[0].provider_code : ""
      if(mode == 'srr') {
        proceed = this.srr
      } else {
        proceed = this.drr
      }

      if(proceed) {
        this.$helpers
          .alert({
            title: this.$t("ui.status"),
            text: this.$t("message.copy_rebate_rate_all_confirm", { name: this.$t("ui." + mode), provider: firstProvider }),
            type: "question",
            showCancelButton: true
          })
          .then(result => {
            if (result.value) {
              if(mode == 'srr'){
                this.setInput('srr', true)
                this.srrCopyAll()
              } else {
                this.setInput('drr', true)
                this.drrCopyAll()
              }
              // this.getVipProviderList();
            } else {
              if(mode == 'srr'){
                this.srr = false
              } else {
                this.drr = false
              }
            }
          });
      } else {
        if(mode == 'srr'){
          this.setInput('srr', false)
          this.srr = false
        } else {
          this.setInput('drr', false)
          this.drr = false
        }
      }
    },
    setInput(mode, isDisabled) {
      let list = this.vipProviderList.slice(1);
      // Loop through the object
      list.forEach((obj, index) => {
        let inputId = mode == 'srr' ? 's_' + obj.provider_code + (index+1) : 'd_' + obj.provider_code + (index+1);
        let inputElement = document.getElementById(inputId);
        if (inputElement) {
          inputElement.disabled = isDisabled;
        }
      })
    },
    srrCopyAll() {
      if(this.srr) {
        let list = this.vipProviderList.slice(1);
        let srrbase = this.vipProviderList[0].self_rebate_rate
        // Loop through the object
        list.forEach((obj, index) => {
          this.vipProviderList[index+1].self_rebate_rate = srrbase;
        })
      }
    },
    drrCopyAll() {
      if(this.drr) {
        let list = this.vipProviderList.slice(1);
        let drrbase = this.vipProviderList[0].downline_rebate_rate
        // Loop through the object
        list.forEach((obj, index) => {
          this.vipProviderList[index+1].downline_rebate_rate = drrbase;
        })
      }
    },
    confirmEditVipProvider: function(e) {
      this.$helpers
        .alert({
          title: this.$t("ui.status"),
          text: this.$t("message.edit_vip_confirm", { name: e.provider_code }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.editVipProvider(e);
          } else {
            this.getVipProviderList();
          }
        });
    },
    editVipProvider: function(e) {
      let url = config.vipProviderEditUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId,
        vip_id: this.selectedVipId,
        provider_code: e.provider_code,
        self_rebate_rate: e.self_rebate_rate,
        downline_rebate_rate: e.downline_rebate_rate,
        audit_by: this.$store.getters.loginId
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.getVipProviderList();
                this.$helpers.showDialog(this.$t("ui.status"), this.$t("message.success"), "success");
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>